import { motion } from "framer-motion";

const platforms = [
  {
    title: "Hydrogel Engineering",
    body: "Designing moisture-retentive, biocompatible polymer networks for targeted healing and controlled drug delivery in advanced wound care.",
    image:
      "/assets/hzbzp3u9_Hydrogel Engineering.jpg",
    tag: "PLATFORM 01",
  },
  {
    title: "Biomaterials",
    body: "Engineering biocompatible materials that interact safely with the body - supporting difficult medical situations and delivering therapies where conventional materials fail.",
    image:
      "/assets/oli5ve9t_Biomaterial.jpg",
    tag: "PLATFORM 02",
  },
  {
    title: "Nanopolymers",
    body: "Designing nanoscale polymers for precise drug delivery and enhanced healing - enabling targeted action at the cellular level in critical care applications.",
    image:
      "/assets/d2a5374cb40198bf95333ca284bde7eaec277589abd57361a9699eab3a0c6011.png",
    tag: "PLATFORM 03",
  },
];

export const ScienceTech = () => {
  return (
    <section
      id="science"
      data-testid="science-section"
      className="relative section-pad bg-[#0A0A0C] overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 divider-grad" />
      <div className="absolute -top-40 -left-40 w-[480px] h-[480px] bg-radial-red opacity-60 blur-3xl pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-2 h-2 rounded-full bg-[#E60000]" />
          <span className="eyebrow">SCIENCE &amp; TECHNOLOGY · 003</span>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-8 font-display text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter font-medium text-white"
          >
            Our Science. <span className="italic font-light">Precision-</span>
            <br />
            engineered for critical care.
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-4 text-base text-blude-textDim self-end text-justify"
          >
            Three core technology platforms - each precision-engineered for
            critical care where conventional solutions fall short.
          </motion.p>
        </div>

        <div className="grid lg:grid-cols-3 gap-5">
          {platforms.map((p, i) => (
            <motion.article
              key={p.tag}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className="card-tile group min-h-[460px] flex flex-col"
              data-testid={`science-card-${i + 1}`}
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-[#0A0A0C]/30 to-transparent" />
                <div className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.3em] text-white/70 px-2.5 py-1 rounded-full bg-black/40 border border-white/10">
                  {p.tag}
                </div>
                <div className="absolute bottom-3 right-3 w-12 h-12 rounded-full border border-[#E60000]/40 flex items-center justify-center bg-black/30 backdrop-blur">
                  <span className="dot-pulse" />
                </div>
              </div>
              <div className="flex-1 p-7 flex flex-col">
                <h3 className="font-display text-2xl text-white tracking-tight">
                  {p.title}
                </h3>
                <p className="mt-3 text-[14.5px] text-blude-textDim leading-relaxed text-justify">
                  {p.body}
                </p>
                <div className="mt-auto pt-6 flex items-center justify-between text-[11px] font-mono tracking-widest text-white/40">
                  <span>BLUDE · LAB</span>
                  <span className="group-hover:text-[#FF2400] transition-colors">
                    EXPLORE →
                  </span>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

